import { useTranslation } from 'react-i18next';
import TableEmptyRow from 'components/others/TableEmptyRow';
import ObjectStatusHistoryTableRow from './ObjectStatusHistoryTableRow';
import type { ObjectStatusHistoryRow } from '../model';

interface ObjectStatusHistoryTableBodyProps {
    rows: ObjectStatusHistoryRow[];
    loading: boolean;
}

const ObjectStatusHistoryTableBody = ({ rows, loading }: ObjectStatusHistoryTableBodyProps) => {
    const { t } = useTranslation(['Objects']);

    if (!rows.length) {
        return (
            <tbody>
                <TableEmptyRow colSpan={4} className="text-center text-muted py-4">
                    {loading ? '\u00A0' : t('objectClose.empty')}
                </TableEmptyRow>
            </tbody>
        );
    }

    return (
        <tbody>
            {rows.map((row) => (
                <ObjectStatusHistoryTableRow key={row.ID} row={row} />
            ))}
        </tbody>
    );
};

export default ObjectStatusHistoryTableBody;
